<div class="gcontainer bwhite">
  <div class="row breadcrumb-header align-items-center sticky-header">
    <div class="col-md-4">
      <nav aria-label="breadcrumb" class="mt-8">
        <ol class="breadcrumb">
          <li
            class="breadcrumb-item active breadcrumb cursor"
            aria-current="page"
            (click)="reDirectUrl()"
            tabindex="0">
            Dashboard
          </li>
          @if (worksheetRecords) {
            <li class="breadcrumb-item active" aria-current="page">
              {{ worksheetRecords.company.name }} -  {{ worksheetRecords.project.projectName }}
            </li>
          }
          </ol>
        </nav>
      </div>
      <div class="col-md-8 d-flex justify-content-end align-items-center gap-2">
        <button
          mat-raised-button
          (click)="printTargetWeights()">
          Print Target Weights
        </button>
        <!-- SAVE -->
        <button
          mat-raised-button
          color="primary"
          (click)="saveTable()">
          Save Table
        </button>
        <!-- HISTORY -->
        @if (isAdmin()) {
          <button
            mat-raised-button
            (click)="compactionHistory()">
            <mat-icon>history</mat-icon>
            History
          </button>
        }
        <!-- ACTIONS -->
        <button
          mat-raised-button
          color="primary"
          [matMenuTriggerFor]="headerMenu">
          ACTIONS
        </button>
        <mat-menu #headerMenu="matMenu">
          <button mat-menu-item (click)="viewSubmissionForm()">
            <mat-icon>visibility</mat-icon>
            <span>View Submission Form</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <!-- HEADER CARD -->
    <mat-card class="bsmokewhite">
      <mat-card-content>
        <div class="row">
          <div class="col-md-1 worksheet-header-column-first">
            <h1 class="mat-h1">Native Soil</h1>
            <p>Compaction</p>
          </div>
          <div class="col-md-1 worksheet-header-column-middle">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data"
                  >
                  {{ worksheetRecords.project.referenceId }}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Reference</mat-label>
          </div>
          <div class="col-md-2 worksheet-header-column-middle">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data word-break-anyware"
                  >
                  {{ worksheetRecords.company.name || '-'}}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Customer</mat-label>
          </div>
          <div class="col-md-2 worksheet-header-column-middle">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data word-break-anyware"
                  >
                  {{ worksheetRecords.project.projectName }}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Project Name</mat-label>
          </div>
          <div class="col-md-1 worksheet-header-column-middle">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data word-break-anyware"
                  >
                  {{ worksheetRecords.project.projectNumber || '-'}}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Project Number</mat-label>
          </div>
          <div class="col-md-1 worksheet-header-column-middle">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data"
                  >
                  {{ worksheetRecords.project.storageCompartment || '-' }}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Storage Location</mat-label>
          </div>
          <div class="col-md-1 worksheet-header-column-middle">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data"
                  >
                  {{ worksheetRecords.project.sampleReceivedDate
                  ? (worksheetRecords.project.sampleReceivedDate | utcToLocal:'date')
                  : '-' }}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Samples Received</mat-label>
          </div>
          <div class="col-md-1 worksheet-header-column-middle">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data"
                  >
                  {{ worksheetRecords.project.instructionsConfirmedAt
                  ? (worksheetRecords.project.instructionsConfirmedAt | utcToLocal:'date')
                  : '-' }}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Instructions Confirmed</mat-label>
          </div>
          <div class="col-md-1 worksheet-header-column-last">
            <div class="pr-32">
              @if (worksheetRecords) {
                <span
                  class="mat-header-data"
                  >
                  {{ worksheetRecords.project.dueDate
                  ? (worksheetRecords.project.dueDate | utcToLocal:'date')
                  : '-' }}
                </span>
              }
            </div>
            <mat-label class="mat-header-subtitle">Due Date</mat-label>
          </div>
          <div class="col-md-1 d-flex justify-content-end">
            <div class="days-badge" [ngClass]="{'danger': (daysLeft) < 10,'normal': (daysLeft) >= 10}">
              <span class="days-value">
                {{ daysLeft }}
              </span>
              <span class="days-label">Days</span>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <div class="row middle-header">
      <!-- Notes section -->
      <div class="col-md-11 d-flex justify-content-start flex-wrap gap-3">
        <div>
          <div class="row">
            @if (note) {
              <div>
                <mat-label class="mat-subtitle-2 bold-title">
                  @if (note.updatedBy) {
                    <span class="d-inline">
                      {{ note.updatedBy.firstName }} {{ note.updatedBy.lastName }}:
                    </span>
                  }
                  @if (note.createdAt) {
                    <span class="d-inline">
                      {{ note.createdAt | utcToLocal: 'date' }}
                      {{ note.createdAt | utcToLocal: 'time' }}
                    </span>
                  }
                </mat-label>
              </div>
            }

            @if (!note) {
              <div style="min-height: 60px">
                <p class="note-text truncate-label">No Notes Available.</p>
              </div>
            }
          </div>
          <div class="row">
            @if (note) {
              <span
                class="note-text mat-subtitle-2"
                matTooltipClass="my-custom-tooltip"
                #tooltip="matTooltip"
                [matTooltip]="note.text">
                {{ noteText }}
              </span>
            }
          </div>
          <div class="row">
            <div class="d-flex justify-content-start flex-wrap gap-3">
              <a class="link-text-data" (click)="openViewNotesDialog()" href="javascript:void(0);">
                <img src="../../../../assets/icons/New Window.svg" />
                Notes
              </a>
              <a class="link-text-data" (click)="openViewInstructionsDialog()" href="javascript:void(0);">
                <img src="../../../../assets/icons/New Window.svg" />
                Instructions
              </a>
              <app-customer-attachments
                class="worksheet-attachements"
                [projectId]="projectId"
                [backgroundClass]="'gray'"
                [showSuccess]="false">
              </app-customer-attachments>
            </div>
          </div>
          <div class="row">
            <div class="d-flex justify-content-start flex-wrap gap-3">
              <a class="link-text-data" (click)="asReceivedWorksheet()" href="javascript:void(0);">
                <img src="../../../../assets/icons/New Window.svg" />As-Received
              </a>

              <a class="link-text-data" (click)="moistureConditioningWorksheet()" href="javascript:void(0);">
                <img src="../../../../assets/icons/New Window.svg" />Moisture
              </a>

              <a class="link-text-data" (click)="singleProctorWorksheet()" href="javascript:void(0);">
                <img src="../../../../assets/icons/New Window.svg" />Proctor
              </a>

              <a class="link-text-data disabled-link" (click)="compactionWorksheet()" href="javascript:void(0);">
                <img src="../../../../assets/icons/New Window.svg" />Compaction
              </a>

              <a class="link-text-data" (click)="thermalResistivityWorksheet()" href="javascript:void(0);">
                <img src="../../../../assets/icons/New Window.svg" />TR
              </a>
            </div>
          </div>
        </div>
        <!-- OVEN DATE, Wet Test Data, Dry Test Data section -->
        <div>
          <div class="test-data-text d-flex align-items-center gap-2">
            <div class="edit-icon-wrapper clickable-row"
              (click)="openProjectDetailsComponent('Oven Date', 'ovenDate')">

              <img
                class="edit-icon"
                src="../../../../assets/icons/Edit.svg" />

                <span class="link-text-custom">
                  Oven Date {{ worksheetRecords?.project?.ovenDate ? ': ' + worksheetRecords?.project?.ovenDate : '' }}
                </span>
              </div>
            </div>

            <div class="test-data-text d-flex align-items-center gap-2">
              <div class="edit-icon-wrapper clickable-row"
                (click)="openProjectDetailsComponent('Wet Test Data', 'wetTestData')">

                <img
                  class="edit-icon"
                  src="../../../../assets/icons/Edit.svg" />

                  <span class="link-text-custom">
                    Wet Test Data {{ worksheetRecords?.project?.wetTestData ? ': ' + worksheetRecords?.project?.wetTestData : '' }}
                  </span>
                </div>
              </div>

              <div class="test-data-text d-flex align-items-center gap-2">
                <div class="edit-icon-wrapper clickable-row"
                  (click)="openProjectDetailsComponent('Dry Test Data', 'dryTestData')">

                  <img
                    class="edit-icon"
                    src="../../../../assets/icons/Edit.svg" />

                    <span class="link-text-custom">
                      Dry Test Data {{ worksheetRecords?.project?.dryTestData ? ': ' + worksheetRecords?.project?.dryTestData : '' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-1 d-flex flex-column align-items-end gap-1">
              @if (worksheetRecords?.project?.geothermField) {
                <mat-chip class="chipset-green">
                  <span class="text-white chip-text">Geotherm Field Test</span>
                </mat-chip>
              }

              @if (worksheetRecords?.project?.rushTesting) {
                <mat-chip class="chipset-warning">
                  <img src="./../../../assets/icons/rush-warning-icon.svg" class="icon-position" />
                  <span class="chip-text">Rush</span>
                </mat-chip>
              }
            </div>
          </div>

          <!-- MAT TABLE ************************************************************* -->
          @if (isInstructionsConfirmed) {
            <div class="row mt-3">
              <div class="col-12">
                <table mat-table [dataSource]="dataSource" class="material-table custom-table">
                  <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                      <mat-checkbox
                        (click)="$event.stopPropagation()"
                        (change)="masterToggle()"
                        [checked]="isAllSelected()"
                        [indeterminate]="isIndeterminate()"
                        tabindex="-1">
                      </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row"
                      (click)="$event.stopPropagation()">
                      <mat-checkbox
                        (click)="$event.stopPropagation()"
                        (change)="toggleSelection(row)"
                        [checked]="selection.isSelected(row)"
                        tabindex="-1">
                      </mat-checkbox>
                    </td>
                  </ng-container>
                  <!-- Sample ID Column -->
                  <ng-container matColumnDef="sampleId">
                    <th mat-header-cell *matHeaderCellDef>Sample Id</th>
                    <td mat-cell *matCellDef="let element">{{ element.sampleId }}</td>
                  </ng-container>
                  <!-- Compaction Effort Column -->
                  <ng-container matColumnDef="effort">
                    <th mat-header-cell *matHeaderCellDef>Compaction Effort</th>
                    <td mat-cell *matCellDef="let element">{{ element.effort?.toString() === '0' ? 'Tube' : element.effort }}</td>
                  </ng-container>
                  <!-- Depth Column -->
                  <ng-container matColumnDef="depth">
                    <th mat-header-cell *matHeaderCellDef>Depth</th>
                    <td mat-cell *matCellDef="let element">{{ element.displayDepth }}</td>
                  </ng-container>
                  <!-- Lab Spec Moisture Content Column -->
                  <ng-container matColumnDef="labSpecMoistureContent">
                    <th mat-header-cell *matHeaderCellDef>Lab Spec Moisture Content</th>
                    <td mat-cell *matCellDef="let element">{{ element.labSpecMoistureContent }}</td>
                  </ng-container>
                  <!-- In-House Id Column -->
                  <ng-container matColumnDef="inHouseId">
                    <th mat-header-cell *matHeaderCellDef>In-House Id</th>
                    <td mat-cell *matCellDef="let element" class="cell-stack">
                      <input matInput [(ngModel)]="element.inHouseId" class="table-input"
                        [attr.data-row-id]="element.id"
                        [attr.data-type]="'inHouseId'"
                        (keydown.enter)="focusNextRow($event, element.id, 'inHouseId')"
                        (ngModelChange)="updateCalculations(element)"
                        (wheel)="preventNumberInputChange($event)"
                        (keydown.arrowup)="$event.preventDefault()"
                        (keydown.arrowdown)="$event.preventDefault()"/>
                      </td>
                    </ng-container>
                    <!-- Mold + Probe Weight Column -->
                    <ng-container matColumnDef="mouldPlusProbeTare">
                      <th mat-header-cell *matHeaderCellDef>Mold + Probe Weight</th>
                      <td mat-cell *matCellDef="let element" class="cell-stack">
                        <input
                          type="number"
                          matInput [(ngModel)]="element.mouldPlusProbeTare" class="table-input"
                          [attr.data-row-id]="element.id"
                          [attr.data-type]="'mouldPlusProbeTare'"
                          (focus)="onFocusClearZero(element, 'mouldPlusProbeTare')"
                          (blur)="onBlurRestoreZero(element, 'mouldPlusProbeTare')"
                          (keydown.enter)="focusNextRow($event, element.id, 'mouldPlusProbeTare')"
                          (ngModelChange)="updateCalculations(element)"
                          (wheel)="preventNumberInputChange($event)"
                          (keydown.arrowup)="$event.preventDefault()"
                          (keydown.arrowdown)="$event.preventDefault()"/>
                        </td>
                      </ng-container>
                      <!-- Sample Diameter Column -->
                      <ng-container matColumnDef="soilDiameter">
                        <th mat-header-cell *matHeaderCellDef>Sample Diameter</th>
                        <td mat-cell *matCellDef="let element" class="cell-stack">
                          <input
                            type="number"
                            matInput [(ngModel)]="element.soilDiameter" class="table-input"
                            [attr.data-row-id]="element.id"
                            [attr.data-type]="'soilDiameter'"
                            (focus)="onFocusClearZero(element, 'soilDiameter')"
                            (blur)="onBlurRestoreZero(element, 'soilDiameter')"
                            (keydown.enter)="focusNextRow($event, element.id, 'soilDiameter')"
                            (ngModelChange)="updateCalculations(element)"
                            (wheel)="preventNumberInputChange($event)"
                            (keydown.arrowup)="$event.preventDefault()"
                            (keydown.arrowdown)="$event.preventDefault()"/>
                          </td>
                        </ng-container>
                        <!-- Sample Height Column -->
                        <ng-container matColumnDef="tubeHeight">
                          <th mat-header-cell *matHeaderCellDef>Sample Height</th>
                          <td mat-cell *matCellDef="let element" class="cell-stack">
                            <input
                              type="number"
                              matInput [(ngModel)]="element.tubeHeight   " class="table-input"
                              [attr.data-row-id]="element.id"
                              [attr.data-type]="'tubeHeight'"
                              (focus)="onFocusClearZero(element, 'tubeHeight')"
                              (blur)="onBlurRestoreZero(element, 'tubeHeight')"
                              (keydown.enter)="focusNextRow($event, element.id, 'tubeHeight')"
                              (ngModelChange)="updateCalculations(element)"
                              (wheel)="preventNumberInputChange($event)"
                              (keydown.arrowup)="$event.preventDefault()"
                              (keydown.arrowdown)="$event.preventDefault()"/>
                            </td>
                          </ng-container>
                          <!-- Minus Column -->
                          <ng-container matColumnDef="minus">
                            <th mat-header-cell *matHeaderCellDef>Minus</th>
                            <td mat-cell *matCellDef="let element" class="cell-stack">
                              <input
                                type="number"
                                matInput [(ngModel)]="element.minus" class="table-input"
                                [attr.data-row-id]="element.id"
                                [attr.data-type]="'minus'"
                                (focus)="onFocusClearZero(element, 'minus')"
                                (blur)="onBlurRestoreZero(element, 'minus')"
                                (keydown.enter)="focusNextRow($event, element.id, 'minus')"
                                (ngModelChange)="updateCalculations(element)"
                                (wheel)="preventNumberInputChange($event)"
                                (keydown.arrowup)="$event.preventDefault()"
                                (keydown.arrowdown)="$event.preventDefault()"/>
                              </td>
                            </ng-container>
                            <!-- Weight per Layer Column -->
                            <ng-container matColumnDef="weightPerLayer">
                              <th mat-header-cell *matHeaderCellDef>Weight Per Layer</th>
                              <td mat-cell *matCellDef="let element">
                                {{ element.weightPerLayer?.toFixed(1) }}
                              </td>
                            </ng-container>
                            <!-- Target Weight Column -->
                            <ng-container matColumnDef="targetWeight">
                              <th mat-header-cell *matHeaderCellDef>Target Weight</th>
                              <td mat-cell *matCellDef="let element">
                                {{ element.targetWeight?.toFixed(1) }}
                              </td>
                            </ng-container>
                            <!-- Actual Weight Column -->
                            <ng-container matColumnDef="wetPlusTare">
                              <th mat-header-cell *matHeaderCellDef>Actual Weight</th>
                              <td mat-cell *matCellDef="let element" class="cell-stack">
                                <input
                                  matInput
                                  type="number"
                                  step="0.01"
                                  [(ngModel)]="element.wetPlusTare"
                                  class="table-input"
                                  [attr.data-row-id]="element.id"
                                  [attr.data-type]="'wetPlusTare'"
                                  [class.weight-green]="isActualWeightInRange(element)"
                                  [class.weight-yellow]="isActualWeightWarning(element)"
                                  [class.weight-red]="isActualWeightOutOfRange(element)"
                                  (focus)="onFocusClearZero(element, 'wetPlusTare')"
                                  (blur)="onBlurRestoreZero(element, 'wetPlusTare')"
                                  (keydown.enter)="focusNextRow($event, element.id, 'wetPlusTare')"
                                  (ngModelChange)="updateCalculations(element)"
                                  (wheel)="preventNumberInputChange($event)"
                                  (keydown.arrowup)="$event.preventDefault()"
                                  (keydown.arrowdown)="$event.preventDefault()"/>
                                </td>
                              </ng-container>
                              <!-- TR Column -->
                              <ng-container matColumnDef="wetTr">
                                <th mat-header-cell *matHeaderCellDef>TR</th>
                                <td mat-cell *matCellDef="let element" class="cell-stack">
                                  <input
                                    matInput
                                    type="number"
                                    step="0.01"
                                    class="wetTr"
                                    [(ngModel)]="element.wetTr"
                                    class="table-input"
                                    [attr.data-row-id]="element.id"
                                    [attr.data-type]="'wetTr'"
                                    (focus)="onFocusClearZero(element, 'wetTr')"
                                    (blur)="onBlurRestoreZero(element, 'wetTr')"
                                    (keydown.enter)="focusNextRow($event, element.id, 'wetTr')"
                                    (ngModelChange)="updateCalculations(element)"
                                    (wheel)="preventNumberInputChange($event)"
                                    (keydown.arrowup)="$event.preventDefault()"
                                    (keydown.arrowdown)="$event.preventDefault()"/>
                                  </td>
                                </ng-container>
                                <!-- Geotherm Soil Description -->
                                <ng-container matColumnDef="geothermSoilDescription">
                                  <th mat-header-cell *matHeaderCellDef>Geotherm Soil Description</th>
                                  <td mat-cell *matCellDef="let element; let i = index" class="cell-stack">
                                    @if (isFirstRowOfSample(element, i)) {
                                      <input matInput
                                        [(ngModel)]="element.geothermSoilDescription" class="table-input"
                                        [attr.data-row-id]="element.id"
                                        [attr.data-type]="'geothermSoilDescription'"
                                        (keydown.enter)="focusNextDescription($event)"
                                        (ngModelChange)="copyDescriptionToGroup(element)"
                                        (keydown.arrowup)="$event.preventDefault()"
                                        (keydown.arrowdown)="$event.preventDefault()"/>
                                    }
                                  </td>
                                </ng-container>
                                <ng-container matColumnDef="isCompactionCompleted">
                                  <th mat-header-cell *matHeaderCellDef>Completed</th>
                                  <td mat-cell *matCellDef="let element">
                                    <mat-checkbox
                                      [(ngModel)]="element.isCompactionCompleted"
                                      [disabled]="!canCompleteRow(element)"
                                      (change)="completeRow(element, $event)"
                                      class="green-checkbox">
                                    </mat-checkbox>
                                  </td>
                                </ng-container>
                                <!-- Assigned To Column -->
                                <ng-container matColumnDef="assignedTo">
                                  <th mat-header-cell *matHeaderCellDef>Assigned To</th>
                                  <td mat-cell *matCellDef="let element" class="text-center">
                                    {{ element.assignedTo ?? '' }}
                                  </td>
                                </ng-container>
                                <ng-container matColumnDef="action">
                                  <th mat-header-cell *matHeaderCellDef></th>
                                  <td mat-cell *matCellDef="let element">
                                    <button mat-icon-button [matMenuTriggerFor]="menu" tabindex="-1">
                                      <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #menu="matMenu">
                                      <button mat-menu-item (click)="openAssignToDialog(element)">
                                        <span class="menu-text">
                                          <img src="/assets/icons/User-multiple.svg" alt="Assign" />
                                          &nbsp; Assign To
                                        </span>
                                      </button>
                                    </mat-menu>
                                  </td>
                                </ng-container>
                                <!-- Header Row -->
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <!-- Data Row -->
                                <tr mat-row
                                  [class.dotted-bottom-border]="isLastRowOfEffort(row, i)"
                                  [class.bold-bottom-border]="isLastRowOfSample(row, i)"
                                  [class.moisture-incomplete]="!isMoistureWorksheetCompleted(row)"
                                  *matRowDef="let row; let i = index; columns: displayedColumns;">
                                </tr>
                              </table>
                            </div>
                          </div>
                        }
                        @if (isInstructionsConfirmed === false) {
                          <div class="warning-container">
                            <div class="warning">
                              <mat-icon>warning</mat-icon>
                              <span>Instructions are not confirmed.</span>
                            </div>
                          </div>
                        }
                      </div>